module.exports = __webpack_public_path__ + "media/images/sidebar-bg-1179c0a0.jpg";